import { type FeatureModule } from '@store/features/types';

import { adminV2Api } from './api';

export const adminV2Feature: FeatureModule = {
  id: 'adminV2',
  name: 'Admin V2',

  dependencies: [], // No dependencies on other features

  reducers: {},

  middleware: [],

  // No persistence needed for AdminV2 - it's all API-based
  persistence: {
    enabled: false,
  },

  // No sync needed for AdminV2
  sync: {
    enabled: false,
  },

  setup: _store => {
    // Feature initialized
  },

  cleanup: store => {
    // Invalidate all AdminV2 cache tags on cleanup
    store.dispatch(
      adminV2Api.util.invalidateTags([
        'Provider',
        'Note',
        'Transcription',
        'Encounter',
        'Appointment',
        'Group',
      ]),
    );
  },
};
